import { Card } from  '@mui/material';
import { Box, styled } from '@mui/system';

const CardRoot = styled(Card)((data) => ({
  height: '100%',
  padding: '20px 24px',
  marginBottom:data.margenbajo,
  background: data.colores
}));

const CardTitle = styled('div')(({ subtitle }) => ({
  fontSize: '1rem',
  fontWeight: '500',
  textTransform: 'capitalize',
  marginBottom: !subtitle && '16px',
}));

const SimpleCard = ({ children, title, subtitle, icon, colores, elevacion,margenbajo }) => {
  return (
    <CardRoot elevation={(elevacion ? elevacion:6)} margenbajo={(margenbajo ? margenbajo: null)} colores={colores}  >
      <CardTitle subtitle={subtitle}>{title}</CardTitle>
      {subtitle && <Box sx={{ mb: 2 }}>{subtitle}</Box>}
      {children}
    </CardRoot>
  );
};

export default SimpleCard;
